module.exports = __webpack_public_path__ + "img/Close-Dark.a0142b1.svg";